export const CAN_SEND_ZERO_AMOUNT = ['algorand'];
